let IntentosPost6 = 0;
const PostXlsUpload = (url, file, content, usuario, resp) => {
    let data = new FormData();
    data.append('archivo', file.files[0]);
    data.append('ID', `${usuario}_calif`);
    data.append('Seccion', content.seccion);
    data.append('Corte', content.corte);
    data.append('Usuario', usuario);
    
    fetch(url, {
        method: 'POST', 
        body: data,
        /* credentials: "same-origin" */})
    .then(response => {
        response.text().then(respuesta);
        function respuesta(data) {
            resp (data);
        }
    },error => {
        IntentosPost6++;
        (IntentosPost6 > 5) ? IntentosPost6 = 0 : PostXlsUpload(url, file, content, usuario, (respuesta) => {
            resp(respuesta)
        })
        console.error('Ocurrió un error al cargar. Reintentando. ', error);
    })
}

export default PostXlsUpload;


// WEBPACK FOOTER //
// ./src/shared/PostXlsUpload.jsx